<script>
  import { _ } from 'svelte-i18n'
  import { createEventDispatcher }  from 'svelte'
  import { just_switched_to_local_fonts } from '../../../stores'
  import { parseLocalFonts } from '../../../modules/fontDetection';
  import Button from '../../../elements/Button.svelte'
  
  export let permission_denied = false
  export let has_extension = false
  export let browser = {name: "your browser"}

  const dispatch = createEventDispatcher()

  async function requestFontPermission() {
    try {
      const local_fonts_data = await self.queryLocalFonts()
      const status = await navigator.permissions.query({ name: "local-fonts" })
      if (status.state === "granted") {
        console.log('Fonts - permission granted for local fonts')
        sendPermissionEvent()
        parseLocalFonts(local_fonts_data)
        $just_switched_to_local_fonts = true
      } else if (status.state === "denied") {
        console.log('Fonts - permission denied, status: ' + status.state)
        permission_denied = true
      }
    } catch(e) {
      // Handle error, e.g. user cancelled the operation.
      console.error(`Local font access not available: ${e.message}`)
    }
  }

  function sendPermissionEvent() {
    if (typeof window.gtag == "undefined") return
    gtag('event', 'lfa_permission_granted');
  }
</script>


{#if permission_denied}
  <h2>
    Allow Wordmark to show your downloaded fonts here as well.<br>
    Click the icon next to the site address and toggle Fonts on.<br>
  </h2>
  <p class="mt3">
    {$_('inserts.yourFonts.lfaSupport')}<br>
    <a href="/help/font-detection/" target="_blank">{$_('inserts.yourFonts.readMore')}</a>
  </p>
{:else}
  {#if $just_switched_to_local_fonts}
    <h2>
      With your permission, your fonts are now visible on Wordmark
    </h2>
    <p>
      {browser.name} will remember your permission. You can manage your permissions by clicking the icon next to the site address.
    </p>
    <p>
      <b>Remember, you will need to restart your browser after installing new fonts.</b>
    </p>
  {:else if has_extension}
    <h2>
      {browser.name} can show your fonts without the extension
    </h2>
    <p>
      Just like allowing your browser to access your camera and microphone on a video chat website, you can allow it to show your fonts on Wordmark. This method is more reliable for seeing your installed fonts. We recommend switching to this method.
    </p>
  {:else}
    <h2>
    {$_('inserts.yourFonts.didYou')}<br>
    With your permission, {browser.name} can show them here as well!
  </h2>
  {/if}
  {#if !$just_switched_to_local_fonts}
    <div class="button_wrapper">
      <Button kind="accent" on:click={requestFontPermission}>Allow {browser.name} to show your fonts</Button>
      {#if has_extension}
      <Button kind="outline" on:click={() => dispatch('hide')}>{$_('buttons.notNow')}</Button>
      {/if}
    </div>
    <p class="faded">
      {$_('inserts.yourFonts.lfaSupport')}<br>
      <a href="/help/font-detection/" target="_blank">{$_('inserts.yourFonts.readMore')}</a>
    </p>
  {/if}  
{/if}

<style>
  .button_wrapper {
    margin: 3rem 0;
  }
  .button_wrapper :global(button) {
    margin-right: 1rem;
  }
  .faded,
  .faded a {
    color: var(--c-text-faded);
  }
  .faded a:hover {
    color: var(--c-text);
  }
  .mt3 {
    margin-top: 3rem;
  }
  p {
    max-width: 80rem;
    margin-top: 2rem;
    font-size: 1.8rem;
    line-height: 2.5rem;
  }
  p b {
    color: var(--c-accent);
  }
</style>